'use client';

import { c as _c } from "react/compiler-runtime";
import type { PasswordContext, PasswordRule } from './passwordRules';
type Props = {
  rules: PasswordRule[];
  ctx: PasswordContext;
};

/**
 * The rule stack. Newest rule first, and failing rules float above satisfied
 * ones — the rule you just broke is always the one at the top of the screen.
 */
const PasswordRuleList = t0 => {
  const $ = _c(15);
  const {
    rules,
    ctx
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== ctx || $[1] !== rules) {
    let t5;
    if ($[6] !== ctx) {
      t5 = (a, b) => {
        const aPasses = a.test(ctx) ? 1 : 0;
        const bPasses = b.test(ctx) ? 1 : 0;
        return aPasses - bPasses;
      };
      $[6] = ctx;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    const ordered = [...rules].reverse().sort(t5);
    t1 = "fun-password-rules";
    t2 = "polite";
    t3 = "mt-6 flex flex-col gap-2";
    let t6;
    if ($[8] !== ctx) {
      t6 = rule => {
        const passes = rule.test(ctx);
        return <li key={rule.id} className={`flex items-start gap-3 rounded-xl border p-3 transition-colors duration-300 ${passes ? "border-ds-border-subtle bg-background-secondary/60 text-textGray" : "border-ds-border-standard bg-background-secondary text-textPrimary"}`}><span aria-hidden="true" className={passes ? "text-green-500" : "text-red-500"}>{passes ? "\u2713" : "\u2715"}</span><span className="text-sm"><span className="font-emphasis">Rule {rule.id}</span><span className="sr-only">{passes ? " satisfied" : " not satisfied"}</span>: {rule.label(ctx)}</span></li>;
      };
      $[8] = ctx;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t4 = ordered.map(t6);
    $[0] = ctx;
    $[1] = rules;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <ul id={t1} aria-live={t2} className={t3}>{t4}</ul>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default PasswordRuleList;